export default "__VITE_ASSET__wP$vJ6AH__"